





















































import {Component, Vue} from 'vue-property-decorator'
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTextField from "@/components/Dialog/parts/DialogTextField.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import {Util} from "@/_global/utils";
import ThemeVariableStore from '@/store/modules/ThemeVariableStore'
import ImagesStore, { IMAGE_TYPES } from '@/store/modules/ImagesStore'

@Component({
    components: {
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
        ImageUploader,
    },
})
export default class AddBadgeDialog extends Vue {
    private badgeName: string = "";
    private badgeImageUrls: { [language_code: string]: string } = {};

    get languages(): CMS.Language[] {
        if (!ThemeVariableStore.all.value)
            return [];

        return ThemeVariableStore.all.value.languages;
    }

    private onChangeName(name: string): void {
        this.badgeName = name;
    }

    private onChangeImage(value: string, languageCode: string): void {
        Vue.set(this.badgeImageUrls, languageCode, value);
    }

    private onDeleteImage(languageCode: string): void {
        Vue.delete(this.badgeImageUrls, languageCode);
    }

    get newBadge(): CMS.Image {
        const tmpId: number = Util.getTempId(ImagesStore.all);

        return {
            id: tmpId,
            image_type: IMAGE_TYPES.BADGE,
            name: this.badgeName,
            image_urls: this.badgeImageUrls
        }
    }
}
